import { Controller } from "@hotwired/stimulus";

// Drives the campaign dashboard's status switch (activate / close / reopen).
// Each action POSTs to the matching API endpoint and reloads the page on
// success — server-rendered KPIs/state stay accurate without DOM diffing.
export default class extends Controller {
  static values = {
    activateUrl: String,
    closeUrl:    String,
    reopenUrl:   String,
    csrfToken:   String
  };

  async activate(event) {
    event?.preventDefault?.();
    if (!confirm("Activer la campagne ? Les distributions seront créées et les notifications envoyées aux membres.")) return;
    await this._statusCall(this.activateUrlValue, "Activation impossible.");
  }

  async close(event) {
    event?.preventDefault?.();
    if (!confirm("Clôturer la campagne ? Plus aucune réponse ne pourra être collectée.")) return;
    await this._statusCall(this.closeUrlValue, "Clôture impossible.");
  }

  async reopen(event) {
    event?.preventDefault?.();
    if (!confirm("Rouvrir la campagne ? Les répondants pourront à nouveau soumettre des réponses.")) return;
    await this._statusCall(this.reopenUrlValue, "Réouverture impossible.");
  }

  async _statusCall(url, errorMsg) {
    if (!url) return;
    try {
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfTokenValue || (document.querySelector('meta[name="csrf-token"]')?.content || "")
        },
        credentials: "same-origin"
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error((data.errors || [data.error || errorMsg]).join(", "));
      }
      window.location.reload();
    } catch (e) {
      alert(e.message);
    }
  }
}
